import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  isAdmin: false,
  isLogged: false,
  isRouteAuthorized: false,
  currentUser: {},
};

export default {
  actions,
  getters,
  mutations,
  state,
};
